import React, { useState, useEffect } from "react";
import classes from "./rulessearch.module.scss";
import { FormControl, TextField, Button, Grid,Box, InputLabel, Select } from "@mui/material";
import { Icon, DatePicker } from "@genesis/ui-kit";
import axios from "axios";
import axiosInstance from "../../../../../Shared/Utill/AxiosConfig";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useNavigate, NavLink, useLocation } from "react-router-dom";
import { CheckIsUserAdmin } from "../../../../../Shared/Utill/Utills";
import SnackBar from "../../../../../Shared/Snackbar/Snackbar";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import MoreVertIcon from '@mui/icons-material/MoreHoriz';
import {
  AddPlusIcon,
  SearchIcon,
} from "../../../../../Resources/availabilityicon/IconUtils";
import AdminControlsDataGrid from "../../../AdminControlsDataGrid";
import { constants } from "../../../../../Shared/Url/Constants";
import DeleteRuleDialog from "../Delete/DeleteRuleDialog";
import {AllControlSearchView} from "../../RuleAssignments/Search/RuleAssignmentsSearch";
import moment from 'moment';
import { isEmpty, toUpperCaseString  } from "../../../../../Shared/Utill/Utills";

const RulesSearch = () => {
  const personDetails = useSelector(
    (state) => state.personStatic.personStaticData
  );
  const urlDetails = useSelector((state) => state.url.urlData);
  const token = Cookies.get("X_TKN");
  const history = useNavigate();

  const [ruleId, setRuleId] = useState(null);
  const [effectiveDate, setEffectiveDate] = useState(null);
  const [maxDaysOff, setMaxDaysOff] = useState(null);
  const [maxMorningOff, setMaxMorningOff] = useState(null);
  const [maxEveningOff, setMaxEveningOff] = useState(null);
  const [splitShifts, setSplictShifts] = useState(null);
  const [preferences, setPreferences] = useState(null);

  const [isAlertOpen, setAlertOpen] = React.useState({});
  const { message, severity, open } = isAlertOpen || {};
  const location = useLocation();

  const [searchValue, setSearchValue] = useState([]);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [aRaID, setARaID] = useState(null);
  const [searchResponse, setSearchResponse] = useState([]);

  //
  const [options, setMenuOptions] = useState([
    {choice:'Edit', disabled: false},
    {choice:'Duplicate',disabled:false},
    {choice:'Delete',disabled:false},    
  ]);
  const ITEM_HEIGHT = 48;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const openOption = Boolean(anchorEl);
  const [selectedRowData, setSelectedRowData] = useState(null);

  // check user role at page
  CheckIsUserAdmin();

  useEffect(() => {
    let isDeleteSuccess = location.state !== null ? true : false;
    if(isDeleteSuccess){
      setAlertOpen({
        open: true,
        severity:  'success',
        message : location.state.message,
      })
    }
  },[options]);


  const handleAlertNotifClose = () => {
    setAlertOpen({});
  };

  const columns = [
    { field: 'ruleid', headerName: 'Rule ID', width: "100" },
    { field: 'effective_date', headerName: 'Effective Date', width: "140" },
    { field: 'preferences_group', headerName: 'Preferences Group', width: "150" },
    { field: 'maxdaysoff', headerName: 'Max Days Off', width: "130" },
    { field: 'maxmorningsoff', headerName: 'Max Mornings Off', width: "140" },
    { field: 'maxeveningsoff', headerName: 'Max Evenings Off', width: "140" },
    { field: 'splitshifts', headerName: 'Split Shifts', width: "120" },
    { field: 'preferences', headerName: 'Preferences', width: "120" },

    { field: 'actions', headerName: 'Actions', width: "180", renderCell: (params) => {  
      console.log("rules search",params.row.id);
      let data= params.row;
      return(
        <div>
   <IconButton
     aria-label="more"
     id="long-button"
     aria-controls={openOption ? 'long-menu' : undefined}
     aria-expanded={openOption ? 'true' : undefined}
     aria-haspopup="true"
     onClick={(event) => handleClick(event,data)}
   >
     <MoreVertIcon /> <div></div>
   </IconButton>
   <Menu
     id="long-menu"
     MenuListProps={{
       'aria-labelledby': 'long-button',
     }}
     anchorEl={anchorEl}
     open={openOption}
     onClose={handleClose}
     PaperProps={{
       style: {
         maxHeight: ITEM_HEIGHT * 4.5,
         width: '15ch',
       },
     }}
   >
     {options.map((option) => (
       <>
       <MenuItem key={option} disabled={option.disabled} value={option} className={classes.menu_item} onClick={(event) => handleOptionMenuClick(event)} >
         {option.choice}
       </MenuItem>
       </>
     ))}
   </Menu>
  </div>)      }},
    ];

  //------

   // option menu callbacks
   const handleClick = (event,data) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowData(data);
  };

const handleClose = (event) => {
    setAnchorEl(null);
  };

const handleOptionMenuClick = (event) => {
  
    setAnchorEl(null);
    let optionClicked = event.nativeEvent.target.outerText;
    let myData = selectedRowData;
    
    if(optionClicked == 'Edit') {
      history("Edit", { state: {id: selectedRowData.id, flag: "E"}});
    }
    
    if(optionClicked == 'Delete') {
        onDeleteAction();
    }
  
    if(optionClicked == 'Duplicate') {
      history("Duplicate", { state: {id: selectedRowData.id, flag: "D",origin:"Search"}})
    }
  }
//------

const ValidateSearchFields = () => {
  let isDataValid = true;

  if (!isEmpty(ruleId) && isNaN(ruleId)) {
    isDataValid = false;
    setAlertOpen({
      open: true,
      severity: "error",
      message: "Rule ID should be Numeric.",
    });
  }
  if (!isEmpty(maxDaysOff) && isNaN(maxDaysOff)) {
    isDataValid = false;
    setAlertOpen({
      open: true,
      severity: "error",
      message: "Max Days Off should be Numeric.",
    });
  }
  if (!isEmpty(maxMorningOff) && isNaN(maxMorningOff)) {
    isDataValid = false;
    setAlertOpen({
      open: true,
      severity: "error",
      message: "Max Mornings Off should be Numeric.",
    });
  }

  if (!isEmpty(maxEveningOff) && isNaN(maxEveningOff)) {
    isDataValid = false;
    setAlertOpen({
      open: true,
      severity: "error",
      message: "Max Evenings Off should be Numeric.",
    });
  }
  return isDataValid;
};
  const handleSearch = () => {
    // validation for fields
    if (!ValidateSearchFields()) {
      return;
    }

  let effectiveDateFormated = effectiveDate == null ? null : moment(effectiveDate).format('YYYY-MM-DD');

 // data for searching
 let data = {
   ruleId : ruleId,
   allow_splitshifts: splitShifts,
   nbrdays_max_off: maxDaysOff,
   nbrdays_max_am_off : maxMorningOff,
   nbrdays_max_pm_off : maxEveningOff,
   preferences_visible : preferences,
   effective_date : effectiveDateFormated,
  }

axiosInstance.post(`${urlDetails.uiEnvUrls.REACT_APP_WFM_AVAILABILITY_API_BASE_URL}${constants.WFM_AVL_RULE_SEARCH}`, 
data,
{
 headers:{
 'Content-Type': 'application/json',
 'Authorization':'Bearer ' + token,
 }
}).then((res) => {
 
 let tmparr = []
 console.log("response",res.data);
 setSearchResponse(res.data);
 res.data.map(obj => {
    let tmpobj = {}
    tmpobj.id = obj.arId;
    tmpobj.ruleid = obj.ruleId;
    tmpobj.effective_date = moment(obj.effectiveDate).format('MMM DD, YYYY');
    tmpobj.preferences_group = obj.pwhgrpnbr;
    tmpobj.maxdaysoff = obj.nbrdays_max_off;
    tmpobj.maxmorningsoff = obj.nbrdays_max_am_off;
    tmpobj.maxeveningsoff = obj.nbrdays_max_pm_off;
    tmpobj.splitshifts = toUpperCaseString(obj.allow_splitshifts) == 'N' ? "Off" : "On";
    tmpobj.preferences = toUpperCaseString(obj.preferences_visible) == 'N' ? "Off" : "On"; 

    tmparr.push(tmpobj);
 });
 setSearchValue(tmparr);
 if (res.data.length > 0  && res.data[0].ruleId === 999) {
  setMenuOptions(
    [
      {choice:'Edit', disabled: false},
      {choice:'Duplicate',disabled:false},
      {choice:'Delete',disabled:true},    
    ]
  )
 } else {
  setMenuOptions(
    [
      {choice:'Edit', disabled: false},
      {choice:'Duplicate',disabled:false},
      {choice:'Delete',disabled:false},    
    ]
  )
 }
 
}).catch((err) => {
 if(err.message === 'Network Error') {
   history("/somethingwentwrong", {state:`Please logout and try again `})
 }else {
   history("/somethingwentwrong", {state:`${constants.WFM_AVL_RULE_SEARCH}...failed`})
   }
});

  };

  //-- delete
  const onCloseDialog = () => {
    setOpenDeleteDialog(false);
  };

  const onDeleteCallback = (responseType, message) => {
    onCloseDialog();
    //handle success / failue
    setAlertOpen({
      open: true,
      severity: responseType,
      message: message,
    });
    // refresh data
    if (responseType == "success") {
      // refresh handle search
      handleSearch();
    }
  };
 
  const onDeleteAction = () => {
    //set current selected delete item
    //setARaID(araId);
    setOpenDeleteDialog(true);
  };

  const onSplitShiftDropDownSelect = (event) => {
    let splitShifts = event.target.value;
    setSplictShifts(splitShifts);
  }
  
  const onPrefDropDownSelect = (event) => {
    let preferenceVal = event.target.value;
    setPreferences(preferenceVal);
  }
  
  return (
    <div className={classes.pagemargin}>
        <AllControlSearchView/>
      <div className={classes.pagetitle}>Rules</div>
      <div className={classes.icon_text_wrap}>
        <div className={classes.icon_text}>
          <AddPlusIcon />
          <NavLink
            to={"Add"}
            style={{ textDecoration: "underline" }}
            state={{id: "", flag: "A"}}
            className={classes.label_text}
          >
            Add
          </NavLink>
        </div>
      </div>

      <div className={classes.searchbox}>
        <SnackBar
          open={open}
          message={message}
          severity={severity}
          onClose={handleAlertNotifClose}
        ></SnackBar>

        <Grid container spacing={3}>
          <Grid key={0} item xs={2}>
          <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Rule ID (Opt)"
                onChange={(e) => setRuleId(e.target.value)}
                value={ruleId}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
            <DatePicker
             label="Effective Date (Opt)"
             renderInput={(params) => (
               <TextField {...params}  />
                 )}
             inputFormat="MMM dd, yyyy"
             value={effectiveDate}
             onChange={(newValue) => {
             setEffectiveDate(newValue);
             }}
             showDaysOutsideCurrentMonth
             />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Max Days Off (Opt)"
                onChange={(e) => setMaxDaysOff(e.target.value)}
                value={maxDaysOff}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Max Mornings Off (Opt)"
                onChange={(e) => setMaxMorningOff(e.target.value)}
                value={maxMorningOff}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%" }}>
              <TextField
                label="Max Evenings Off (Opt)"
                onChange={(e) => setMaxEveningOff(e.target.value)}
                value={maxEveningOff}
              />
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%", marginTop: 10}}>
            <InputLabel id="demo-select-basic-label">Split Shifts (Opt)</InputLabel>
            <Select
             labelId="demo-select-basic-label"
             id="demo-select-basic"
             label="Split Shifts (Opt)"
             onChange={e => onSplitShiftDropDownSelect(e)}
             value={splitShifts}>
              <MenuItem key={"1"} value={"y"}>{"On"}</MenuItem>
              <MenuItem key={"2"} value={"n"}>{"Off"}</MenuItem>
              <MenuItem key={"3"} value={null}>{"Blank"}</MenuItem>
            </Select>
            </FormControl>
          </Grid>
          <Grid key={1} item xs={2}>
            <FormControl style={{ minWidth: "100%", marginTop: 10 }}>
            <InputLabel id="demo-select-basic-label">Preferences (Opt)</InputLabel>
            <Select
             labelId="demo-select-basic-label"
             id="demo-select-basic"
             label="Preferences (Opt)"
             onChange={e => onPrefDropDownSelect(e)}
             value={preferences}>
              <MenuItem key={"1"} value={"y"}>{"On"}</MenuItem>
              <MenuItem key={"2"} value={"n"}>{"Off"}</MenuItem>
              <MenuItem key={"3"} value={null}>{"Blank"}</MenuItem>
            </Select>
            </FormControl>
          </Grid>
          <Grid key={2} item xs={2}>
            <Button
              style={{
                marginLeft: "10px",
                paddingTop: "14px",
                paddingBottom: "14px",
                paddingLeft: "80px",
                paddingRight: "80px",
                marginRight: "5px",
                marginTop: '10px'
              }}
              onClick={handleSearch}
            >
              Search
            </Button>
          </Grid>
        </Grid>
      </div>
      <AdminControlsDataGrid columns= { columns} rows = {searchValue} width={"90%"}   />  
      {openDeleteDialog && (
          <DeleteRuleDialog
            onCloseDialog={onCloseDialog}
            onDeleteCallback={onDeleteCallback}
            arAId={selectedRowData.id}
            effectiveDate={selectedRowData.effective_date}
            ruleId={selectedRowData.ruleid}
          />
        )}
    </div>
  );
};

export default RulesSearch;

